<template>
    <li class="nav-item has-sub"
        v-show="hasChildren"
        :class="{'open': opened, 'hover': hover}"
        @mouseover="hover = true"
        @mouseleave="hover = false"
    >
        <a href="#" @click.prevent="toggleExpand">
            <i :class="icon"></i>
            <span class="menu-title" data-i18n="Dashboard">{{ label }}</span>
            <span class="badge badge-light-danger badge-pill badge-round float-right me-2" v-if="count">{{
                    count
                }}</span>
        </a>
        <ul class="menu-content"
            v-show-slide="expanded"
            @slide-close-end="opened = false"
        >
            <slot></slot>
        </ul>
    </li>
</template>

<script>
export default {
    name: 'MenuDropdown',
    props: ['icon', 'label', 'count'],
    data() {
        return {
            hover: false,
            expanded: false,
            opened: false,
            hasChildren: true,
        }
    },
    watch: {
        activeSub(newVal) {
            if (newVal === 1) {
                this.open();
            }
        },
    },
    beforeUpdate() {
        this.hasChildren = this.checkForSlotContent();
    },
    created() {
        this.hasChildren = this.checkForSlotContent();
        if (this.activeSub) {
            this.open();
        }
    },
    methods: {
        open() {
            this.opened = true;
            this.expanded = true;
        },
        toggleExpand() {
            if (!this.expanded) {
                this.opened = true;
            }
            this.expanded = !this.expanded;
        },
        checkForSlotContent() {
            const checkForContent = (hasContent, node) => hasContent || node.tag || (node.text && node.text.trim());
            return this.$slots.default && this.$slots.default.reduce(checkForContent, false);
        },
    },
}
</script>
